import { SwiperOptions } from "swiper";

const swiperOptions: SwiperOptions = {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  autoplay: {
    delay: 12000,
    disableOnInteraction: true
  },
  direction: "horizontal",
  effect: "slide",
  simulateTouch: false,
  speed: 600,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
};

export default swiperOptions;
